import { __rest } from "tslib";
import * as React from 'react';
import { AvatarBase } from './Avatar.base';
import { st, classes } from './Avatar.st.css';
import { AvatarSize } from './types';
/** Avatar is a type of element that visually represents a user, either as an image, placeholder or text (name initials). */
class Avatar extends React.Component {
    render() {
        const _a = this.props, { className, size } = _a, rest = __rest(_a, ["className", "size"]);
        return (React.createElement(AvatarBase, Object.assign({}, rest, { className: st(classes.root, { size }, className) })));
    }
}
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
    size: AvatarSize.medium,
};
export { Avatar };
//# sourceMappingURL=Avatar.js.map